// import { useNavigate } from "react-router-dom";
// import { useState } from "react";
import { useEffect } from "react";

// import MyHeader from "./../components/MyHeader";
// import MyButton from "./../components/MyButton";

// //                         0123456789
// // toISOString()의 반환값은 YYYY-MM-DDTHH를 반환
// const getStringDate = (date) => {
//   return date.toISOString().slice(0, 10);
// };

import DiaryEditor from "./../components/DiaryEditor";

const New = () => {
  // 세부 타이틀 바꾸기
  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `감정 일기장 - 새 일기`;
  }, []);
  // const navigate = useNavigate();

  // const [date, setDate] = useState(getStringDate(new Date()));

  return (
    // 아래 부분은 Edit에서도 쓰일 수 있음으로 별도의 컴포로 분리
    // <div>
    //   <MyHeader
    //     // headText={isEdit ? "일기 수정하기" : "새 일기 작성하기"}
    //     headText={"새 일기 작성하기"}
    //     leftChild={
    //       <MyButton text={"< 뒤로가기"} onClick={() => navigate(-1)} />
    //     }
    //     // rightChild={
    //     //   isEdit && (
    //     //     <MyButton
    //     //       text={"삭제하기"}
    //     //       type={"negative"}
    //     //       onClick={handleRemove}
    //     //     />
    //     //   )
    //     // }
    //   />
    //   <div>
    //     {/* section 태그는 의미론적 태그 -> div와 역할은 같음 */}
    //     <section>
    //       <h4>오늘은 언제인가요?</h4>
    //       <div className="input_box">
    //         <input
    //           className="input_date"
    //           value={date}
    //           onChange={(e) => setDate(e.target.value)}
    //           type="date"
    //         />
    //       </div>
    //     </section>
    //   </div>
    // </div>
    <div>
      <DiaryEditor />
    </div>
  );
};

export default New;
